<template>
  <div id="top-account" @click="vGoToAccount">
    <div class="account-img">
      <img src="../assets/img/account.png" alt="Mon compte" />
    </div>
    <div class="account-name hide-xs show-md">
      <span>{{sUsername}} ({{getCompany}})</span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sUsername: ''
    };
  },
  created() {
    let user = JSON.parse(localStorage.getItem("satabapp-user"));
    this.sUsername = user.username;
  },
  computed: {
    getCompany() {
      return this.$store.getters['application/get_application_company'].PLIBSOC
    }
  },
  methods: {
    vGoToAccount() {
      this.$router.push({name: 'account'});
    }
  }
};
</script>

<style>
#top-account {
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: solid 1px #e9e9e9;
  width: 300px;
  height: 100%;
  padding: 0px 60px;
  min-height: 75px;
}

#top-account:hover {
  cursor: pointer;
}

#top-account .account-img {
  width: 20px;
  margin-right: 10px;
  position: relative;
  display: flex;
  align-items: center;
}

#top-account .account-img img {
  min-width: 20px;
}

#top-account .account-name span {
  font-size: var(--fz-md);
}

@media (min-width: 340px) {
  #top-account {
    padding: 0px;
    width: 85px;
  }
  #top-account .account-img {
    margin-right: 0px;
    width: 30px;
  }
}

@media (min-width: 768px) {
  #top-account {
    padding: 0px 60px;
    width: 300px;
  }
  #top-account .account-img {
    margin-right: 10px;
    min-width: 20px;
  }
}

@media (min-width: 768px) {
  #top-account {
    padding: 0px 60px;
    width: auto;
    flex: 1;
  }
}
</style>